import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import CarouselSlider from '../effect-carousel.esm.js';
import '../effect-carousel.esm.js';
import '../effect-carousel.scss';
import '../main.scss';
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Avatar, Box, Card, Chip, Fab, Fade, Typography } from "@mui/material";
import WhatshotTwoToneIcon from '@mui/icons-material/WhatshotTwoTone';
import CircularProgress from '@mui/material/CircularProgress';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { FaCheckCircle, FaLine, FaSave, FaTruckLoading } from "react-icons/fa";
import DoneAllIcon from '@mui/icons-material/DoneAll';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssistantIcon from '@mui/icons-material/Assistant';

const OptionCarousel = ({ label, options = [], images = [], onSelect, selected = [], suggestedOptions=[] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loadingStates, setLoadingStates] = useState({});

  const isMobile = window.innerWidth < 768;
  // const [success, setSuccess] = useState(false);

  const handleClick = async (option) => {
    // setSuccess(false);
   
    setLoadingStates(prev => ({ ...prev, [option]: true }));
    await onSelect(option);
    // setSuccess(true);
    setLoadingStates(prev => ({ ...prev, [option]: false }));
   
  };

  return (
    <Swiper
      effect="carousel"
      grabCursor={true}
      slidesPerView={isMobile ? 1.5 : 1.5}
      speed={250}
      spaceBetween={isMobile ? 10 : 20}
      style={{ paddingY: "10px", width: '100%', height:'auto' }}
      modules={[Autoplay, Navigation, Pagination, CarouselSlider]}
    >
      {options.map((option, index) => (
        <SwiperSlide key={option}
        
        >
          <a
            // className={`${selected.includes(option) ? "selected" : ""} ${
            //   index === activeIndex ? "active" : ""
            // }`}
            onClick={() => handleClick(option)}
          >
            <Card
            
              variant="outlined"
              sx={{
                backgroundColor: selected.includes(option)
                  ? 'rgb(24, 24, 24)'
                  : 'white',
                transition: 'all 0.25s ease',
                borderRadius: 3,
                overflow: 'hidden',
                position: 'relative',
              }}
            >
             
              <Box
                sx={{
                  
                  display: 'flex',
                  flexDirection: 'row',
                  px: 2,
                  py: 1,
                  width:'100%',
                  justifyContent: 'space-between',
                  alignItems:'center',
                  position:'absolute',
                  zIndex:4,
                  bottom:0,
                  borderRadius:3,
                  backdropFilter:'blur(5px)',
                  // backgroundColor:'rgba(0,0,0,0.5)'
                  backgroundColor: selected.includes(option)
                  ? 'rgba(0,0,0,0.5)'
                  : 'rgba(255, 255, 255, 0.5)',


                }}
              >
                <Typography
                  textTransform={'capitalize'}
                  align="left"
                  fontWeight={'bold'}
                  fontSize={'0.85rem'}
                  sx={{
                    color: selected.includes(option)
                      ? 'white'
                      : 'black',
                    transition: 'all 0.25s ease',
                    px: 1,
                    py: 0.5,
                    borderRadius: 1,
                  }}
                >
                  {option}
                </Typography>
                {suggestedOptions.includes(option) ? (
               <>
             <Box
             sx={{
              display:'flex',
              flexDirection:'column',
              gap:0,
              // justifyItems:'center',
              // justifyContent:'center',
              // alignContent:'center',
              alignItems:'center'
             }}
             >
               <Avatar
                
                sx={{
                  bgcolor:'rgb(0, 0, 0,0.0)',
                  width: 25, 
                  height: 25,

                  
                }}
                >
                 
                 <AssistantIcon 
                 sx={{p:0.5,
                   color:selected.includes(option)? "white" : "black" 
                 }}
                 
                 
                 /> 
                 </Avatar>
                 <Typography
                 color={selected.includes(option)? "white" : "black"}
                 fontWeight={''} fontSize={'0.5rem'}>Recommended</Typography>
                 </Box>
               </>
             
                )
              
                 : null}
               
              </Box>
                <img
                  src={images[index] || ""}
                  alt={option}
                  loading="lazy"
                  style={{
                    width: '100%',
                    height: 'auto',
                    minHeight:'37.5dvh',
                    borderRadius: 0,
                    objectFit: 'cover',
                  }}
                />
                {loadingStates[option] && (
                  <Fade in={true} timeout={250}>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '45%',
                        transform: 'translate(-50%, -50%)',
                        m: 1,
                      }}
                    >
                      <Fab
                        size="small"
                        aria-label="save"
                        sx={{ backgroundColor: 'rgba(255, 255, 255, 0.52)' }}
                      >
                        <DoneAllIcon />
                      </Fab>
                      <svg width={0} height={0}>
                        <defs>
                          <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                            <stop offset="0%" stopColor="#e01cd5" />
                            <stop offset="100%" stopColor="#1CB5E0" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <CircularProgress
                        size={48}
                        thickness={2.5}
                        sx={{
                          color: 'white',
                          position: 'absolute',
                          top: -4,
                          left: -4,
                          zIndex: 1,
                        }}
                      />
                    </Box>
                  </Fade>
                )}
                {!loadingStates[option] && selected.includes(option) && (
                  <Chip
                    label={
                      <Typography fontWeight={'bold'} color={'white'} fontSize={'0.8rem'}>
                        Selected
                      </Typography>
                    }
                    size="small"
                    sx={{
                      position: 'absolute',
                      bottom: '20%',
                      left: 10,
                      backgroundColor: 'rgba(1, 1, 1, 0.5)',
                      backdropFilter:'blur(5px)',
                      
                    }}
                    icon={<CheckCircleIcon color="success" />}
                  />
                )}
          
             
            </Card>
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default OptionCarousel;